import { useState } from "react";

// ─────────────────────────────────────────────
// ADD / REMOVE BADGES HERE
// ─────────────────────────────────────────────
const BADGES = [
  {
    href: "https://peerpush.net/p/creatorcomment",
    label: "PeerPush",
    sublabel: "Just Launched",
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
      </svg>
    ),
  },
  {
    href: "https://www.producthunt.com/products/creatorcomment?embed=true&amp;utm_source=badge-featured&amp;utm_medium=badge&amp;utm_campaign=badge-creatorcomment",
    label: "Product Hunt",
    sublabel: "Find Us On",
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="#f97316">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 13H9v-2h4c.55 0 1-.45 1-1s-.45-1-1-1H9V9h4c1.66 0 3 1.34 3 3s-1.34 3-3 3z" />
      </svg>
    ),
  },
  {
    href: "https://chromewebstore.google.com/detail/gbffbncfnnodmgcpkdmpnclghfcnmojm",
    label: "Chrome Web Store",
    sublabel: "5.0 ★ Extension",
    icon: (
      <svg width="15" height="15" viewBox="0 0 48 48">
        <path fill="#EA4335" d="M24 14h18.4A20 20 0 0 0 5.6 14z" />
        <path fill="#4285F4" d="M42.4 14A20 20 0 0 1 22.3 43.9L31 28.5A10 10 0 0 0 34 24z" />
        <path fill="#34A853" d="M5.6 14A20 20 0 0 0 25.7 43.9L17 28.5A10 10 0 0 1 14 24z" />
        <circle cx="24" cy="24" r="7" fill="white" />
        <circle cx="24" cy="24" r="5" fill="#4285F4" />
      </svg>
    ),
  },
];

// ─────────────────────────────────────────────
// SINGLE BADGE PILL
// ─────────────────────────────────────────────
function Badge({ href, label, sublabel, icon }) {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        background: "#18181b",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: 100,
        padding: "8px 14px 8px 10px",
        textDecoration: "none",
        transition: "transform 0.15s, border-color 0.15s",
        transform: hovered ? "scale(1.05)" : "scale(1)",
        borderColor: hovered ? "rgba(255,255,255,0.2)" : "rgba(255,255,255,0.1)",
      }}
    >
      {icon}
      <span style={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <span style={{ fontSize: 10, color: "#e5e2e2", lineHeight: 1 }}>
          {label}
        </span>
        <span style={{
          fontSize: 12,
          fontWeight: 600,
          color: "#fff",
          whiteSpace: "nowrap",
          lineHeight: 1.3,
        }}>
          {sublabel}
        </span>
      </span>
    </a>
  );
}

// ─────────────────────────────────────────────
// FOOTER BADGE SHELF
// ─────────────────────────────────────────────
export default function FooterBadges() {
  return (
    <div style={{
      display: "flex",
      flexWrap: "wrap",
      gap: 10,
      alignItems: "center",
      justifyContent:"center"
    }}>
      {BADGES.map((badge) => (
        <Badge key={badge.href} {...badge} />
      ))}
    </div>
  );
}